export const DOC_VERIFIED = 'DOC_VERIFIED';